import {AuthTokens, AuthTokenStatus} from '../types';
import {hasTokenExpired} from './hasTokenExpired';

export const getAuthTokensStatus = (
  tokens: AuthTokens | undefined,
): AuthTokenStatus =>
  tokens === undefined
    ? 'NotAuthenticated'
    : hasTokenExpired(tokens.refreshToken)
    ? 'RefreshTokenExpired'
    : hasTokenExpired(tokens.accessToken)
    ? 'AccessTokenExpired'
    : 'Valid';
